var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcoRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8794 10.8575H19.1725C19.6311 10.8575 20 10.4755 20 10.0005V5.42974C20 5.08336 19.8 4.76912 19.4897 4.637C19.1794 4.50487 18.8242 4.57629 18.5863 4.82268L17.1519 6.30819C14.1313 3.21934 9.2661 3.23005 6.26281 6.3439C3.24573 9.46846 3.24573 14.532 6.26281 17.6566C9.27989 20.7811 14.1693 20.7811 17.1864 17.6566C17.6174 17.2102 17.6174 16.4853 17.1864 16.039C16.7553 15.5926 16.0554 15.5926 15.6244 16.039C13.4693 18.2708 9.9764 18.2708 7.82135 16.039C5.66629 13.8071 5.66629 10.1898 7.82135 7.95795C9.96606 5.73684 13.4314 5.72613 15.5899 7.92225L14.1727 9.39347C13.9348 9.63986 13.8658 10.0077 13.9934 10.329C14.121 10.6504 14.4244 10.8575 14.7589 10.8575H18.8794Z",
    fill: "#00858A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcoRefresh);
export default __webpack_public_path__ + "static/media/Home_ico_refresh.4446cec98aead4404069a0a1aca80fc7.svg";
export { ForwardRef as ReactComponent };